import './ContentAndImageBlock.scss';

import Button from '../../ui/Button/Button';
import React from 'react';
import { Image } from '@sitecore-jss/sitecore-jss-react';

export default function FleetContentImage({ fields }) {
  return (
    <div className={'container fleet-content-image-block'}>
      <div className={'wrapper'} data-aos="fade-up">
        <div className={'card'}>
          <div className={'card_inner'}>
            <div>
              <h3 className={'card_title'}>{fields?.title?.value}</h3>
              <p className={'card_text'}>{fields?.desc?.value}</p>
            </div>
            <div className={'buttons'}>
              {fields?.buttonText?.value && (
                <div className={'buttonWrapper'}>
                  <a href={fields?.buttonUrl?.value?.href}>
                    <Button className={'buttonWrapper_button'} isShowTooltip={false}>
                      {fields?.buttonText?.value}
                    </Button>
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={'image'}>
          <Image field={fields?.image} alt="img" />
        </div>
      </div>
    </div>
  );
}
